const SubAbasProgBasico = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/secsaude/programacao/basico/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasProgBasico;
